import axios from 'axios'
import param from 'jquery-param';
import { isEmpty } from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Vue2Editor from "vue2-editor";

// import VMaps from 'v-maps'
import Main from './controllers/main'

// Componentes de la app
import './components'
import './directives'
import routes from './routes'

// Servicios
import { auth } from './services/auth_service'
import { oauth } from './services/oauth_service'
import { url } from './services/url_service'


// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vue2Editor);

const router = new VueRouter({ routes })

Vue.use(VueRouter)

// Vue.use(VMaps, {
//     key: 'AIzaSyCPOQy9j0sxxC1cLmc1YXSLLlcBvmZp_ZU'
// })

Vue.use({
    install(SuperVue) {
        SuperVue.prototype.$auth = auth
        SuperVue.prototype.$oauth = oauth
        SuperVue.prototype.$window = window
        SuperVue.prototype.$empty = function (str: string) {
            if (str === null || str === undefined) return str
            return isEmpty(str)
        }
    }
})

String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim())
}

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.secured)) {
        if (auth.logged()) {
            await auth.loadData()
            next()
        } else {
            try {
                await auth.refresh()
                await auth.loadData()
                next()
            } catch (ex) {
                next({ name: 'login' })
            }
        }
    } else if (to.matched.some(record => record.meta.external)) {
        //redirect.initialize(to.query['redirect_to'], to.query['bloques'])
        if (oauth.logged()) {
            await oauth.loadData()
            next()
        } else {
            try {
                await oauth.refresh()
                await oauth.loadData()
                next()
            } catch (ex) {
                let codeUrl = await oauth.requestCodeUrl(to.path)
                window.location.assign(codeUrl)
            }
        }
    } else {
        next()
    }
})

axios.defaults.paramsSerializer = function (params) { return param(params) }

axios.interceptors.request.use(async function (request) {
    // if (url.create('/auth/login') != request.url && 'OPTIONS' !== request.method.toUpperCase()) {
    // request.headers['Authorization'] = 'Bearer ' + security.jwt.getRawToken();
    // }
    if (request.url?.startsWith(url.create('/internal')) && ![url.create('/internal/auth/refresh'), url.create('/internal/auth/login')].includes(request.url) && !auth.logged()) {
        await auth.refresh()
    }
    if (request.url?.startsWith(url.create('/external')) && request.url !== url.create('/external/oauth/refresh') && !oauth.logged()) {
        await oauth.refresh()
    }
    request.withCredentials = true
    return request;
}, function (error) {
    return Promise.reject(error)
})

export default new Vue({ el: '#root', render: createElement => createElement(Main), router })
